import { render, staticRenderFns } from "./NewPasswordRequired.vue?vue&type=template&id=1214dd6f&scoped=true&"
import script from "./NewPasswordRequired.vue?vue&type=script&lang=ts&"
export * from "./NewPasswordRequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214dd6f",
  null
  
)

export default component.exports